import React, { useContext, Suspense } from 'react';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Typography, Button, TextField } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import DonutChart from '../../../components/DonutChart';
// Context
import useProductSamplingContext from '../context/useProductSamplingContext';
// Components
import BorderSection from '../../../components/BorderSection';
import ColumnStackedApexChart from '../../../components/ColumnStackedApexChart';
import BarGroupApexChart from '../../../components/BarGroupApexChart';

export default function ProductSamplingDashboardTab() {
  const {
    sdvsrsChart,
    ppsvsrsChart,
    monthlyTrendChart,
    yearSelected,
    setYearSelected,
    handleToggleModal,
  } = useContext(useProductSamplingContext);

  const handleChangeYear = (value) => {
    setYearSelected(moment(value).format('YYYY'));
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
          <BorderSection>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <Typography
                  variant='button'
                  gutterBottom
                  sx={{ display: 'block', fontWeight: 'bold' }}
                >
                  Samples Distributed vs Remaining Samples
                </Typography>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Button
                    variant='text'
                    color='primary'
                    onClick={() => handleToggleModal('sdvsrs')}
                  >
                    View Breakdown
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <Grid md={12}>
              {!sdvsrsChart?.loading ? (
                <Suspense fallback={<LinearProgress />}>
                  <DonutChart
                    value={sdvsrsChart?.total_percentage}
                    size={950}
                    font={95}
                    label={['Distributed', 'Remaining']}
                  />
                </Suspense>
              ) : (
                <LinearProgress />
              )}
            </Grid>
          </BorderSection>
        </Grid>

        <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
          <BorderSection>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <Typography
                  variant='button'
                  gutterBottom
                  sx={{ display: 'block', fontWeight: 'bold' }}
                >
                  Per Product Samples vs Remaining Samples
                </Typography>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Button
                    variant='text'
                    color='primary'
                    onClick={() => handleToggleModal('ppsvsrs')}
                  >
                    View Breakdown
                  </Button>
                </Box>
              </Grid>
            </Grid>
            {!ppsvsrsChart?.loading ? (
              <Suspense fallback={<LinearProgress />}>
                <BarGroupApexChart
                  name='ppsvsrs'
                  data={ppsvsrsChart}
                  series1='Product Samples'
                  series2='Remaining Samples'
                />
              </Suspense>
            ) : (
              <LinearProgress />
            )}
          </BorderSection>
          <BorderSection>
            <Grid container spacing={2}>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Typography
                  variant='button'
                  gutterBottom
                  sx={{ display: 'block', fontWeight: 'bold' }}
                >
                  Monthly Trend
                </Typography>
              </Grid>
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                <DatePicker
                  label='Year'
                  views={['year']}
                  value={yearSelected}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  renderInput={(params) => (
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    <TextField {...params} label='Year' size='small' />
                  )}
                  onChange={(value) => handleChangeYear(value)}
                />
              </Grid>
              <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Button
                    variant='text'
                    color='primary'
                    onClick={() => handleToggleModal('monthly_trend')}
                  >
                    View Breakdown
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box mt={2}>
                  {!monthlyTrendChart?.loading ? (
                    <Suspense fallback={<LinearProgress />}>
                      <ColumnStackedApexChart name='monthly_trend' data={monthlyTrendChart?.data} />
                    </Suspense>
                  ) : (
                    <LinearProgress />
                  )}
                </Box>
              </Grid>
            </Grid>
          </BorderSection>
        </Grid>
      </Grid>
    </Box>
  );
}
